module.exports = __webpack_public_path__ + "img/12 stage property.0abc19fc.jpg";